import { render } from "./Details.vue?vue&type=template&id=5e7e527c"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
script.render = render

export default script